import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

export type Tone = "sun" | "ember" | "sage" | "sky" | "night" | "ash";

export interface BadgeProps {
  tone: Tone;
  children: ReactNode;
  className?: string;
}

const toneStyles: Record<Tone, string> = {
  sun: "bg-tone-sun-soft text-tone-sun",
  ember: "bg-tone-ember-soft text-tone-ember",
  sage: "bg-tone-sage-soft text-tone-sage",
  sky: "bg-tone-sky-soft text-tone-sky",
  night: "bg-tone-night-soft text-tone-night",
  ash: "bg-tone-ash-soft text-tone-ash",
};

export function Badge({ tone, children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-dw-pill px-dw-2 text-xs font-medium",
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
